<template>
  <div class="cashback-interruptor">
    <label :id="idRotulo" class="cashback-interruptor__rotulo">
      {{ rotulo }}
      <HintInfo v-if="ajuda" :texto="ajuda" />
    </label>
    <label class="cashback-interruptor__controle">
      <input
        type="checkbox"
        role="switch"
        class="cashback-interruptor__entrada"
        :checked="value"
        :aria-checked="value ? 'true' : 'false'"
        :aria-labelledby="idRotulo"
        @change="$emit('input', $event.target.checked)"
      />
      <span class="cashback-interruptor__trilho"></span>
      <span class="cashback-interruptor__texto">{{ value ? textoLigado : textoDesligado }}</span>
    </label>
  </div>
</template>

<script>
import HintInfo from "@/components/form/HintInfo.vue";

export default {
  name: "InterruptorCashback",
  components: { HintInfo },

  props: {
    value: { type: Boolean, default: false },
    rotulo: { type: String, required: true },
    textoLigado: { type: String, default: "Sim" },
    textoDesligado: { type: String, default: "Não" },
    ajuda: { type: String, default: "" },
  },

  computed: {
    idRotulo() {
      return `cashback-interruptor-${this._uid}`;
    },
  },
};
</script>

<style scoped>
.cashback-interruptor__rotulo {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 4px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  color: #667085;
}

.cashback-interruptor__controle {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  height: 38px;
  margin: 0;
  cursor: pointer;
}

.cashback-interruptor__entrada {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: 0;
  opacity: 0;
}

.cashback-interruptor__entrada:focus-visible + .cashback-interruptor__trilho {
  box-shadow: 0 0 0 3px rgba(var(--cashback-cor-primaria-rgb), 0.25);
}

.cashback-interruptor__trilho {
  position: relative;
  width: 36px;
  height: 20px;
  flex-shrink: 0;
  border-radius: 20px;
  background-color: #d0d5dd;
  transition: background-color 0.2s;
}

.cashback-interruptor__trilho::after {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #fff;
  transition: transform 0.2s;
}

.cashback-interruptor__entrada:checked + .cashback-interruptor__trilho {
  background-color: var(--cashback-cor-primaria);
}

.cashback-interruptor__entrada:checked + .cashback-interruptor__trilho::after {
  transform: translateX(16px);
}

.cashback-interruptor__texto {
  font-size: 13px;
  color: #344054;
}
</style>
